import {Component, EventEmitter, Input, OnInit, OnChanges, Output, SecurityContext, SimpleChanges} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {ITCIMediaAsset, TCI_MEDIA_DISPLAY_MODE} from "@tci/common";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "ng-marketplace-v2-media",
    templateUrl: "./ng-marketplace-v2-media.component.html",
    styleUrls: ["./ng-marketplace-v2-media.component.less"]
})
export class NgMarketplaceV2MediaComponent implements OnInit, OnChanges {
    @Input() mediaAssets: (ITCIMediaAsset & { cssClass?: string; isYTVideo?: boolean; sanitizedUrl?: SafeResourceUrl})[];
    @Input() mode: TCI_MEDIA_DISPLAY_MODE;
    @Output() mediaAssetsChange = new EventEmitter<ITCIMediaAsset[]>();

    selectedMedia: ITCIMediaAsset;
    hoveredMedia: ITCIMediaAsset;
    resizeAsset = false;
    resizeAssetIndex = 0;
    isResizeVisble = false;
    prefixYTUrl = "https://www.youtube.com/embed/";
    assetsChanged$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    isModalView = false;

    constructor(private sanitize: DomSanitizer) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.mediaAssets) {
            this.assetsChanged$.next(true);
        }
        if (changes.mode) {
            this.isModalView = changes.mode.currentValue === TCI_MEDIA_DISPLAY_MODE.MODE_MODAL_VIEW;
        }
    }

    ngOnInit() {
        this.assetsChanged$.subscribe(val => {
            if (this.mediaAssets.length) {
                this.mediaAssets.forEach(asset => {
                    asset.mediaUrl = asset.mediaUrl || asset.content;
                    if (this.isVideo(asset)) {
                        if (asset.mediaUrl.includes("www.youtube.com") || asset.mediaUrl.includes("youtu.be")) {
                            asset.isYTVideo = true;
                            asset.mediaUrl = this.constructYTUrl(asset.mediaUrl);
                        } else {
                            asset.mediaUrl = asset.mediaUrl + "#t=0.5";
                        }
                        // To avoid cross-site scripting attacks
                        asset.mediaUrl = this.sanitize.sanitize(SecurityContext.URL, asset.mediaUrl);
                        asset.sanitizedUrl = this.sanitize.bypassSecurityTrustResourceUrl(asset.mediaUrl);
                    }
                });
                this.mediaAssets[0].cssClass = "item-selected";
            }
            this.selectedMedia = this.mediaAssets[0];
        });
    }

    isVideo(asset: ITCIMediaAsset): boolean {
        return asset.mimeType && asset.mimeType.includes("video");
    }

    constructYTUrl(rawURL: string): string {
        let YTId = "";
        const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        const matches = rawURL.match(p);
        if (matches) {
            YTId = matches[1];
        }
        // To avoid CORB errors
        return YTId ? `${this.prefixYTUrl}${YTId}?enablejsapi=1&origin=${location.hostname}` : "";
    }

    onMediaSelect(media, index) {
        this.mediaAssets.forEach(asset => { asset.cssClass = ""; });
        this.selectedMedia = media;
        media.cssClass = "item-selected";
        delete this.hoveredMedia;
        this.resizeAssetIndex = index;
    }

    onMouseHover(media) {
        if (!this.isVideo(media)) {
            this.hoveredMedia = media;
        }
    }

    onMouseLeave() {
        delete this.hoveredMedia;
    }

    toggleResizeAsset(value = true) {
        this.resizeAsset = value;
    }

    toggleResizeBtn(value) {
        this.isResizeVisble = value;
    }

    prevAsset() {
        const currentIndex = this.resizeAssetIndex - 1;
        if (currentIndex >= 0) {
            this.onMediaSelect(this.mediaAssets[currentIndex], currentIndex);
        }
    }

    nextAsset() {
        const currentIndex = this.resizeAssetIndex + 1;
        if (currentIndex !== this.mediaAssets.length) {
            this.onMediaSelect(this.mediaAssets[currentIndex], currentIndex);
        }
    }
}
